export default "__VITE_ASSET__DaIZT$VQ__"